export var isEmptyArray = function isEmptyArray(array) {
  return !array || array.length === 0;
};
export var isNotEmptyArray = function isNotEmptyArray(array) {
  return !isEmptyArray(array);
};